var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Divider as MuiDivider } from '@mui/material';
var StyledDivider = styled(MuiDivider)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", ";\n"], ["\n  margin: ", ";\n"])), function (_a) {
    var margin = _a.margin, orientation = _a.orientation;
    return (orientation === 'horizontal' ? "".concat(margin, "px 0") : "0 ".concat(margin, "px"));
});
var Divider = function (props) {
    var _a = props.margin, margin = _a === void 0 ? 32 : _a, _b = props.orientation, orientation = _b === void 0 ? 'horizontal' : _b, _c = props.variant, variant = _c === void 0 ? 'fullWidth' : _c;
    return _jsx(StyledDivider, { flexItem: true, margin: margin, orientation: orientation, variant: variant });
};
export default Divider;
var templateObject_1;
